import { render, staticRenderFns } from "./national_identity_document.vue?vue&type=template&id=0b84df74&"
import script from "./national_identity_document.vue?vue&type=script&lang=js&"
export * from "./national_identity_document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports